import { useCallback } from 'react';
import { Button, Col, Grid, Row } from 'rsuite';
import { convertNumberToCurrency } from '../../../../common/utils';
import Notice from '../../../user-feedback/Notice';

export const RedirectBasedPayment = ({ children, onClickCallback, loading, totalDue, error }) => {
  const handleButtonClick = useCallback(async () => {
    try {
      const { url } = await onClickCallback();
      window.open(url, '_blank', 'toolbar=0,location=0,menubar=0');
    } catch (err) {
      console.error('Error loading the data', err);
    }
  }, [onClickCallback]);

  return (
    <Grid fluid>
      <Row className="mb-16">
        <Col xs={24}>{children}</Col>
      </Row>
      {error && (
        <Row className="mb-16">
          <Col xs={24}>
            <Notice message={error} />
          </Col>
        </Row>
      )}
      <Row>
        <Col xs={24}>
          <Button
            className="btn-payment btn-soft-blue"
            onClick={handleButtonClick}
            disabled={loading}
          >
            Pay {totalDue && `${convertNumberToCurrency(totalDue)}`}
          </Button>
        </Col>
      </Row>
    </Grid>
  );
};
